__webpack_require__.p = "https://staging.barefootcoders.com/";